export const CO_BORROWER_PREFIX = 'coBorrower';
